import { ReferencedEntry } from 'contentful';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SubscriptionPlan } from 'src/api/contentful/contentTypes.cloverdotcom';
import { getField } from 'src/utils/EntryUtil';
import { Environment } from 'src/utils/Environment';
import { useSalesChannel } from '../SalesChannel/SalesChannel';

export function useSubscriptionPlan() {
  const { planSchedule } = useSalesChannel();
  const { t } = useTranslation();

  /*
   * This formats the plan schedule from:
   * [ SalesChannelPricing ]
   * to
   * {
   *   SalesChannelPricing.plan.planId : SalesChannelPricing.price,
   * }
   */
  const planPrices = useMemo(() => {
    return planSchedule.reduce((acc, planPrice) => {
      acc[getField(getField(planPrice, 'plan') , 'planId', '')] = getField(planPrice, 'price');
      return acc;
    }, {});
  }, [ planSchedule ]);

  const getMonthlyPrice = (entry: ReferencedEntry<SubscriptionPlan>) => {
    const configEnv = Environment.current.isDev ? 'PREPROD' : 'PROD';
    const planId = getField(entry, 'planIdConfig', {})[configEnv];
    const planPrice = planId && planPrices[planId] && t('software-plan-price', { price: planPrices[planId] });
    return planPrice;
  };

  return { getMonthlyPrice };
}
